import { render, staticRenderFns } from "./forced-spirometry.vue?vue&type=template&id=42a6ba00&"
import script from "./forced-spirometry.vue?vue&type=script&lang=js&"
export * from "./forced-spirometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "forced-spirometry.vue"
export default component.exports